import { downloadBase64DataUri } from 'vopay';

// Base64 payload in, browser download out. Both endpoints that need this return the file inline in
// their JSON response rather than as a real download, so the data URI is the whole mechanism.
//
// The extension is appended only when the caller's name doesn't already carry it: a strip-then-
// re-append round trip is a no-op for every real caller and mangles anything like `report.pdf.v2`.

export function downloadPdf(data: string, fileName: string) {
  downloadBase64DataUri({
    data,
    fileName: withExtension(fileName, '.pdf'),
    fileType: 'application/pdf',
  });
}

export function downloadCsv(data: string, fileName: string) {
  downloadBase64DataUri({
    data,
    fileName: withExtension(fileName, '.csv'),
    // Deliberately not text/csv: octet-stream is what makes the browser save the file rather than
    // render it in a tab.
    fileType: 'application/octet-stream',
  });
}

function withExtension(fileName: string, extension: string) {
  return fileName.toLowerCase().endsWith(extension) ? fileName : `${fileName}${extension}`;
}
